import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  maxLimit: null,
};
export const maxLimitSlice = createSlice({
  name: "maxLimit",
  initialState,
  reducers: {
    setMaxLimit: (state, action) => {
      state.maxLimit = action.payload;
    },
    setLogoutMaxLimit: (state, action) => {
      state.maxLimit = null;
    },
  },
});
export const { setMaxLimit, setLogoutMaxLimit } = maxLimitSlice.actions;

export default maxLimitSlice.reducer;
